/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeRenderText = exports.mergeWebStyles = exports.WEB_STYLE_ONLY = exports.MOBILE_STYLE_ONLY = void 0;
exports.MOBILE_STYLE_ONLY = '@mobile';
exports.WEB_STYLE_ONLY = '@web';

exports.mergeWebStyles = function (styles) {
  Object.keys(styles).forEach(function (component) {
    var style = styles[component];

    if (style[exports.MOBILE_STYLE_ONLY]) {
      delete style[exports.MOBILE_STYLE_ONLY];
    }

    if (style[exports.WEB_STYLE_ONLY]) {
      var webStyle = style[exports.WEB_STYLE_ONLY];
      Object.assign(styles[component], webStyle);
      delete style[exports.WEB_STYLE_ONLY];
    }
  });
  return styles;
};

exports.safeRenderText = function (txt, t) {
  if (typeof txt === 'string') {
    return t(txt);
  }

  return txt;
};